import { inject, Injectable } from '@angular/core';
import { ShepherdService } from 'angular-shepherd';
import { Router } from '@angular/router';

import { StepsLogin } from './steps/steps.login';
import { StepsInicio } from './steps/steps.inicio';
import { StepsPerfil } from './steps/steps.perfil';
import { StepsConfiguracion } from './steps/steps.configuracion';
import { StepsFacturas } from './steps/steps.facturas';
import { StepsTokens } from './steps/steps.tokens';
import { StepsContactos } from './steps/steps.contactos';
import { StepsPlantillasListar } from './steps/steps.plantillas-listar';
import { StepsPlantillasCrearEditar } from './steps/steps.plantillas-crear-editar';
import { StepsEnviosNuevo } from './steps/steps.envios-nuevo';
import { StepsEnviosConsultar } from './steps/steps.envios-consultar';
import { StepsEnviosVer } from './steps/steps.envios-ver';
import { StepsSellarDocumento } from './steps/steps.sellar-documento';
import { StepsSellosDeTiempoConsultar } from './steps/steps.sellos-de-tiempo-consultar';
import { StepsStripe } from './steps/steps.stripe';
import { StepsSoporte } from './steps/steps.soporte';
import { StepsApi } from './steps/steps.api';
import { ToastService } from '@app/services/toast.service';

@Injectable()
export class TourService {
  private stepsLogin = inject(StepsLogin);
  private stepsInicio = inject(StepsInicio);
  private stepsPerfil = inject(StepsPerfil);
  private stepsEnviosNuevo = inject(StepsEnviosNuevo);
  private stepsConfiguracion = inject(StepsConfiguracion);
  private stepsFacturas = inject(StepsFacturas);
  private stepsTokens = inject(StepsTokens);
  private stepsContactos = inject(StepsContactos);
  private stepsPlantillasListar = inject(StepsPlantillasListar);
  private stepsPlantillasCrearEditar = inject(StepsPlantillasCrearEditar);
  private stepsEnviosConsultar = inject(StepsEnviosConsultar);
  private stepsEnviosVer = inject(StepsEnviosVer);
  private stepsSellarDocumento = inject(StepsSellarDocumento);
  private stepsSellosDeTiempoConsultar = inject(StepsSellosDeTiempoConsultar);
  private stepsStripe = inject(StepsStripe);
  private stepsSoporte = inject(StepsSoporte);
  private stepsApi = inject(StepsApi);
  private router = inject(Router);
  private shepherdService = inject(ShepherdService);
  private toast = inject(ToastService);

  constructor() {
    this.shepherdService.modal = true;
    this.shepherdService.confirmCancel = false;
    this.shepherdService.defaultStepOptions = {
      arrow: true,
      cancelIcon: {
        enabled: false,
      },
      canClickTarget: false,
      modalOverlayOpeningPadding: 2,
      modalOverlayOpeningRadius: 2,
      scrollTo: { behavior: 'smooth', block: 'center' },
    };
  }

  mostrarTour() {
    if (this.router.url === '/' || this.router.url.includes('login')) {
      this.shepherdService.addSteps(this.stepsLogin.crear());
    } else if (this.router.url.includes('inicio')) {
      this.shepherdService.addSteps(this.stepsInicio.crear());
    } else if (this.router.url.includes('perfil')) {
      this.shepherdService.addSteps(this.stepsPerfil.crear());
    } else if (this.router.url.includes('configuracion')) {
      this.shepherdService.addSteps(this.stepsConfiguracion.crear());
    } else if (this.router.url.includes('facturas')) {
      this.shepherdService.addSteps(this.stepsFacturas.crear());
    } else if (this.router.url.includes('tokens')) {
      this.shepherdService.addSteps(this.stepsTokens.crear());
    } else if (this.router.url.includes('contactos')) {
      this.shepherdService.addSteps(this.stepsContactos.crear());
    } else if (this.router.url.includes('plantillas-listar')) {
      this.shepherdService.addSteps(this.stepsPlantillasListar.crear());
    } else if (this.router.url.includes('plantillas-crear-editar')) {
      this.shepherdService.addSteps(this.stepsPlantillasCrearEditar.crear());
    } else if (this.router.url.includes('envios-nuevo')) {
      // Si cancelamos el Tour, tenemos que dejar la página como al principio
      this.shepherdService.onTourFinish = (completeOrCancel: string) =>
        this.stepsEnviosNuevo.porDefecto(completeOrCancel);
      this.shepherdService.addSteps(this.stepsEnviosNuevo.crear());
    } else if (this.router.url.includes('envios-consultar')) {
      this.shepherdService.addSteps(this.stepsEnviosConsultar.crear());
    } else if (this.router.url.includes('envios-ver')) {
      this.shepherdService.addSteps(this.stepsEnviosVer.crear());
    } else if (this.router.url.includes('sellar-documento')) {
      this.shepherdService.onTourFinish = (completeOrCancel: string) =>
        this.stepsSellarDocumento.porDefecto(completeOrCancel);
      this.shepherdService.addSteps(this.stepsSellarDocumento.crear());
    } else if (this.router.url.includes('sellos-de-tiempo-consultar')) {
      this.shepherdService.addSteps(this.stepsSellosDeTiempoConsultar.crear());
    } else if (this.router.url.includes('stripe')) {
      this.shepherdService.addSteps(this.stepsStripe.crear());
    } else if (this.router.url.includes('soporte')) {
      this.shepherdService.addSteps(this.stepsSoporte.crear());
    } else if (this.router.url.includes('api')) {
      this.shepherdService.addSteps(this.stepsApi.crear());
    } else {
      this.toast.error(
        'La ayuda para esta página aún no está disponible.  Disculpe las molestias.'
      );

      return;
    }

    this.shepherdService.start();
  }
}
